var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-sidebar--single"},[_c('h3',{staticClass:"filter--title"},[_vm._v(_vm._s(_vm.$t('general.filter.region')))]),_c('multiselect-region',{on:{"forceSearch":_vm.forceSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }